<template>
    <div class="x-table-server" v-loading="loading">
        <div class="x-table-server-section-title" v-if="showSectionTitle">
            <div class="d-flex align-items-center justify-content-between w-100">
                <div class="title">{{ title }}</div>
                <div class="d-flex align-items-center">
                    <slot name="button-actions"></slot>
                    <x-button-icon icon="fa-light fa-file-arrow-down"
                                   tooltip-content="Descarga masiva"
                                   tooltip-position="top"
                                   @click="clickOtherActionExport()"
                                   v-if="showButtonOtherActionExport"></x-button-icon>
                    <x-button-primary text="Otros reportes"
                                      @click="clickOtherReports()"
                                      v-if="showButtonOtherReports"></x-button-primary>
                    <x-button-primary text="Nuevo"
                                      @click="clickCreate()"
                                      v-if="showButtonNew"></x-button-primary>
                    <el-dropdown v-if="showButtonExport" class="ml-2" @command="clickExport">
                        <x-button-icon icon="fa-light fa-download"
                                       tooltip-content="Exportar"
                                       tooltip-position="top"></x-button-icon>
                        <el-dropdown-menu class="x-table-server-dropdown-menu" slot="dropdown">
                            <el-dropdown-item command="xls">Exportar Excel</el-dropdown-item>
                            <el-dropdown-item command="pdf">Exportar Pdf</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown v-if="showButtonColumns" class="ml-2">
                        <x-button-icon icon="fa-light fa-table-columns"
                                       tooltip-content="Columnas"
                                       tooltip-position="top"></x-button-icon>
                        <el-dropdown-menu class="x-table-server-dropdown-menu" slot="dropdown">
                            <el-checkbox-group v-model="selectVisibleColumns" @change="changeSelectVisibleColumns">
                                <el-checkbox v-for="col in selectColumns" :label="col.value" :key="col.value">
                                    {{ col.label }}
                                </el-checkbox>
                            </el-checkbox-group>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <x-button-icon icon="fal fa-filter"
                                   tooltip-content="Más filtros"
                                   tooltip-position="top"
                                   class="ml-2"
                                   type="warning"
                                   @click="showDialogFilter = true"></x-button-icon>
                </div>
            </div>
        </div>
        <div class="x-table-server-section-widgets" v-if="showWidgets">
            <div class="row">
                <div class="col" v-for="w in widgets">
                    <div class="x-table-server-widget">
                        <div class="x-table-server-widget-label">{{ w.label }}</div>
                        <div class="x-table-server-widget-value">{{ w.value }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="x-table-server-section-filters" v-if="showFilter">
<!--            <div class="row">-->
<!--                <div class="col">-->
                    <div class="row">
                        <template v-for="f in getFiltersInTable(filters)">
                            <div :class="f.class" v-if="f.type === 'select_items'">
                                <div class="x-select">
                                    <label class="x-label">{{ f.label }}</label>
                                    <div style="display: flex">
                                        <el-select v-model="f.value"
                                                   clearable
                                                   filterable
                                                   remote
                                                   reserve-keyword
                                                   placeholder="Buscar por nombre, código interno del producto, escribir mínimo 2 caracteres"
                                                   :remote-method="searchItems"
                                                   @change="changeFilterItem"
                                                   popper-class="x-select-item-search">
                                            <el-option
                                                v-for="item in items"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                                <div class="x-item-search">
                                                    <div class="x-item-search_image"><img :src="item.image"/></div>
                                                    <div class="x-item-search_information">
                                                        <div class="x-item-search_information_name">{{ item.name }}</div>
                                                        <div class="x-item-search_information_description">
                                                            <span v-if="item.information">{{ item.information }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div :class="f.class" v-if="f.type === 'select_persons'">
                                <el-select v-model="f.value"
                                           clearable
                                           filterable
                                           remote
                                           reserve-keyword
                                           placeholder="Buscar por nombre, número del cliente, escribir mínimo 2 caracteres"
                                           :remote-method="searchPersons"
                                           @change="changeFilterPerson"
                                           popper-class="x-select-person-search">
                                    <el-option
                                        v-for="person in persons"
                                        :key="person.id"
                                        :label="person.name"
                                        :value="person.id">
                                        <div class="x-person-search">
                                            <div class="x-item-search_information">
                                                <div class="x-person-search_information_name">{{ person.name }}</div>
                                                <div class="x-person-search_information_description">{{ person.number }}</div>
                                            </div>
                                        </div>
                                    </el-option>
                                </el-select>
                            </div>
                            <div :class="f.class" v-if="f.type === 'select'">
                                <x-select v-model="f.value"
                                          :label="f.label"
                                          :options="f.options"
                                          @input="changeFilter"></x-select>
                            </div>
                            <div :class="f.class" v-if="f.field === 'period'">
                                <div class="row">
                                    <div class="col">
                                        <x-select v-model="f.value"
                                                  :label="f.label"
                                                  :options="f.options"
                                                  @input="changeFilter"></x-select>
                                    </div>
                                    <template v-if="f.value === 'date' || f.value === 'between_dates'">
                                        <div class="col">
                                            <x-date-picker v-model="f.date_start"
                                                           label="Fecha del"
                                                           style="width: 160px"
                                                           @input="changeFilter"></x-date-picker>
                                        </div>
                                    </template>
                                    <template v-if="f.value === 'between_dates'">
                                        <div class="col">
                                            <x-date-picker v-model="f.date_end"
                                                           label="Fecha al"
                                                           style="width: 160px"
                                                           @input="changeDateEnd"></x-date-picker>
                                        </div>
                                    </template>
                                    <template v-if="f.value === 'month' || f.value === 'between_months'">
                                        <div class="col-auto">
                                            <x-date-picker v-model="f.month_start"
                                                           label="Mes del"
                                                           type="month"
                                                           style="width: 160px"
                                                           @input="changeFilter"></x-date-picker>
                                        </div>
                                    </template>
                                    <template v-if="f.value === 'between_months'">
                                        <div class="col-auto">
                                            <x-date-picker v-model="f.month_end"
                                                           label="Mes al"
                                                           type="month"
                                                           style="width: 160px"
                                                           @input="changeMonthEnd"></x-date-picker>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div :class="f.class" v-if="f.type === 'input'">
                                <x-input :label="f.label"
                                         v-model="f.value"
                                         @input="changeFilter"></x-input>
                            </div>
                        </template>
                    </div>
<!--                </div>-->
<!--            </div>-->
        </div>
        <div class="x-table-server-section-content">
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th v-for="col in visibleColumns" :key="col.name" :class="`text-${col.class_col_head}`"
                            :style="col.style">{{ col.label }}
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <slot name="table-rows" :records="records" :columns="visibleColumns"></slot>
                    </tbody>
                </table>
            </div>
            <div class="row justify-content-between" style="margin-top: 8px">
                <div class="col" style="display: flex; align-items: center">
                    Total {{ pagination.rowsNumber }}
                </div>
                <div class="col-auto">
                    <div style="width: 70px">
                        <el-select v-model="pagination.rowsPerPage"
                                   @input="changeFilter">
                            <el-option v-for="p in pagination.pageSizes" :key="p" :value="p">{{ p }}</el-option>
                        </el-select>
                    </div>
                </div>
                <div class="col-12 col-md-auto text-center text-md-right">
                    <el-pagination
                        @size-change="changePageSize"
                        @current-change="changeFilter"
                        layout="prev, pager, next"
                        :pager-count="5"
                        :total="pagination.rowsNumber"
                        :current-page.sync="pagination.page"
                        :page-sizes="pagination.pageSizes"
                        :page-size.sync="pagination.rowsPerPage">
                    </el-pagination>
                </div>
            </div>
        </div>
        <el-dialog :visible="showDialogFilter"
                   :show-close="false"
                   :close-on-click-modal="false"
                   append-to-body
                   custom-class="x-modal-filter-container">
            <div class="x-modal-filter" v-loading="loading">
                <div class="x-modal-filter-header">
                    <div class="title">Filtro</div>
                    <div class="button-close" style="cursor: pointer">
                        <i class="fa-light fa-xmark" @click="showDialogFilter = false"></i>
                    </div>
                </div>
                <div class="x-modal-filter-body">
                    <div class="row q-col-gutter-x-sm q-col-gutter-y-sm">
                        <template v-for="f in filters">
                            <div class="col-12" v-if="f.type === 'select_persons'">
                                <div class="x-select">
                                    <label class="x-label">{{ f.label }}</label>
                                    <div style="display: flex">
                                        <el-select v-model="f.value"
                                                   clearable
                                                   filterable
                                                   remote
                                                   reserve-keyword
                                                   placeholder="Buscar por nombre, número del cliente, escribir mínimo 2 caracteres"
                                                   :remote-method="searchPersons"
                                                   @change="changeFilterPerson"
                                                   popper-class="x-select-person-search">
                                            <el-option
                                                v-for="person in persons"
                                                :key="person.id"
                                                :label="person.name"
                                                :value="person.id">
                                                <div class="x-person-search">
                                                    <div class="x-item-search_information">
                                                        <div class="x-person-search_information_name">{{ person.name }}</div>
                                                        <div class="x-person-search_information_description">{{ person.number }}</div>
                                                    </div>
                                                </div>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" v-if="f.type === 'select_items'">
                                <div class="x-select">
                                    <label class="x-label">{{ f.label }}</label>
                                    <div style="display: flex">
                                        <el-select v-model="f.value"
                                                   clearable
                                                   filterable
                                                   remote
                                                   reserve-keyword
                                                   placeholder="Buscar por nombre, código interno del producto, escribir mínimo 2 caracteres"
                                                   :remote-method="searchItems"
                                                   @change="changeFilterItem"
                                                   popper-class="x-select-item-search">
                                            <el-option
                                                v-for="item in items"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                                <div class="x-item-search">
                                                    <div class="x-item-search_image"><img :src="item.image"/></div>
                                                    <div class="x-item-search_information">
                                                        <div class="x-item-search_information_name">{{ item.name }}</div>
                                                        <div class="x-item-search_information_description">
                                                            <span v-if="item.information">{{ item.information }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </el-option>
                                        </el-select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12" v-if="f.type === 'select'">
                                <x-select v-model="f.value"
                                          :label="f.label"
                                          :options="f.options"
                                          @input="changeFilter"></x-select>
                            </div>
                            <div class="col-12" v-if="f.field === 'period'">
                                <div class="row">
                                    <div class="col-6">
                                        <x-select v-model="f.value"
                                                  :label="f.label"
                                                  :options="f.options"
                                                  @input="changeFilter"></x-select>
                                    </div>
                                    <template v-if="f.value === 'date' || f.value === 'between_dates'">
                                        <div class="col-6">
                                            <x-date-picker v-model="f.date_start"
                                                           label="Fecha del"
                                                           @input="changeDateStart"></x-date-picker>
                                        </div>
                                    </template>
                                    <template v-if="f.value === 'between_dates'">
                                        <div class="col-6">
                                            <x-date-picker v-model="f.date_end"
                                                           label="Fecha al"
                                                           @input="changeDateEnd"></x-date-picker>
                                        </div>
                                    </template>
                                    <template v-if="f.value === 'month' || f.value === 'between_months'">
                                        <div class="col-6">
                                            <x-date-picker v-model="f.month_start"
                                                           label="Mes del"
                                                           type="month"
                                                           @input="changeFilter"></x-date-picker>
                                        </div>
                                    </template>
                                    <template v-if="f.value === 'between_months'">
                                        <div class="col-6">
                                            <x-date-picker v-model="f.month_end"
                                                           label="Mes al"
                                                           type="month"
                                                           @input="changeMonthEnd"></x-date-picker>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <div class="col-12" v-if="f.type === 'input'">
                                <x-input :label="f.label"
                                         v-model="f.value"
                                         @input="changeFilter"></x-input>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>

import XButtonPrimary from "./XButtonPrimary";
import XInput from "./XInput";
import XSelect from "./XSelect.vue";
import XDatePicker from "./XDatePicker.vue";
import XButtonIcon from "./XButtonIcon.vue";
import XInputItemSearch from "./XInputItemSearch.vue";

export default {
    name: 'XTableServer',
    components: {XInputItemSearch, XButtonIcon, XDatePicker, XSelect, XInput, XButtonPrimary},
    props: {
        title: {
            type: String,
            required: true,
        },
        resourceInit: {
            default: null,
        },
        resource: {
            type: String,
            required: true,
        },
        showSectionTitle: {
            type: Boolean,
            default: true
        },
        showFilter: {
            type: Boolean,
            default: false
        },
        showButtonNew: {
            type: Boolean,
            default: true
        },
        showButtonOtherReports: {
            type: Boolean,
            default: false
        },
        showWidgets: {
            type: Boolean,
            default: true
        },
        showButtonExport: {
            type: Boolean,
            default: false
        },
        showButtonColumns: {
            type: Boolean,
            default: true
        },
        showButtonFilters: {
            type: Boolean,
            default: true
        },
        showButtonOtherActionExport: {
            type: Boolean,
            default: false
        },
        additionalFilters: {
            type: Array,
            default() {
                return []
            }
        },
        reloadTableServer: {
            type: Boolean,
            default: false
        },
        fileTypeOtherActionExport: {
            type: String,
            default: 'pdf',
        }
    },
    data() {
        return {
            loading: false,
            showDialogFilter: false,
            tableName: null,
            columns: [],
            filters: [],
            widgets: [],
            records: [],
            pagination: {},
            visibleAllColumns: [],
            visibleColumns: [],
            selectVisibleColumns: [],
            selectColumns: [],
            items: [],
            persons: [],
            value: ''
        }
    },
    async mounted() {
        this.initForm()
        this.initTableServer();
        await this.getInitTable();
        await this.changeFilter();
    },
    watch: {
        reloadTableServer(val) {
            if (val) {
                this.onRequest({pagination: this.pagination});
                this.$emit('update:reloadTableServer', false)
            }
        }
    },
    methods: {
        initForm() {
            this.loading = false
            this.tableName = null
            this.columns = []
            this.filters = []
            this.widgets = []
            this.records = []
            this.pagination = {
                sortBy: null,
                descending: null,
                page: 1,
                rowsPerPage: 1,
                rowsNumber: 1,
                pageSizes: []
            }
            this.visibleColumns = []
            this.selectVisibleColumns = []
            this.selectColumns = []
            this.items = []
            this.persons = []
        },
        initTableServer() {
            this.pagination = {
                sortBy: null,
                descending: null,
                page: 1,
                rowsPerPage: 1,
                rowsNumber: 1,
                pageSizes: []
            };
        },
        getVisibleColumns() {
            let svc = [];
            this.columns.forEach(col => {
                let only_export = col.hasOwnProperty('only_export') ? col.only_export : false
                if (!col.locked && !only_export) {
                    this.selectColumns.push({
                        'label': col.label,
                        'value': col.name,
                    });
                    if (this.visibleAllColumns.includes(col.name)) {
                        svc.push(col.name);
                    }
                }
            })
            this.selectVisibleColumns = svc;
        },
        changeSelectVisibleColumns(update = true) {
            let vc = this.selectVisibleColumns
            let h = [];

            this.columns.forEach(hc => {
                let only_export = hc.hasOwnProperty('only_export') ? hc.only_export : false
                if ((vc.indexOf(hc.name) > -1 || hc.locked) && (!only_export)) {
                    h.push(hc)
                }
            });
            this.visibleColumns = h;
            if (update) {
                this.updateVisibleColumns();
            }
        },
        async getInitTable() {
            this.loading = true;
            let resourceInit = (!this.resourceInit) ? this.resource : this.resourceInit;
            await this.$http.get(`/${resourceInit}/init_data_table`)
                .then(response => {
                    this.tableName = response.data.table_name;
                    this.columns = response.data.columns;
                    this.filters = response.data.filters;
                    this.visibleAllColumns = response.data.visible_columns;
                    this.pagination.sortBy = response.data.pagination.sort_by;
                    this.pagination.descending = response.data.pagination.descending;
                    this.pagination.rowsPerPage = response.data.pagination.limit;
                    this.pagination.pageSizes = _.orderBy(response.data.pagination.page_sizes);
                });
            this.getVisibleColumns();
            this.changeSelectVisibleColumns(false);
            this.loading = false;
        },
        async onRequest(data) {
            const {page, rowsPerPage, sortBy, descending} = data.pagination
            const fetchCount = rowsPerPage === 0 ? this.pagination.rowsNumber : rowsPerPage;
            this.loading = true;
            this.records = [];
            this.widgets = [];

            await this.$http.post(`/${this.resource}/records`, {
                'tableName': this.tableName,
                'page': page,
                'limit': fetchCount,
                'sortBy': sortBy,
                'descending': descending,
                'filters': this.filters.concat(this.additionalFilters),
            })
                .then(response => {
                    let data = response.data;
                    this.records = data.data;
                    this.widgets = data.widgets;
                    this.pagination.page = data.meta.current_page
                    this.pagination.rowsPerPage = data.meta.per_page
                    this.pagination.rowsNumber = data.meta.total
                    this.pagination.sortBy = data.meta.sort_by
                    this.pagination.descending = data.meta.descending
                });
            this.loading = false;
        },
        async changeFilter() {
            await this.onRequest({pagination: this.pagination});
        },
        async changePageSize() {
            this.pagination.page = 1;
            await this.changeFilter();
        },
        updateVisibleColumns() {
            this.$http.post(`/${this.resource}/update_visible_columns`, {
                'tableName': this.tableName,
                'visible_columns': this.selectVisibleColumns
            })
        },
        async clickExport(type) {
            this.loading = true;
            const {sortBy, descending} = this.pagination
            await this.$http({
                url: `/${this.resource}/export`,
                method: 'POST',
                responseType: 'blob',
                data: {
                    'sortBy': sortBy,
                    'descending': descending,
                    'filters': this.filters.concat(this.additionalFilters),
                    'select_columns': this.selectVisibleColumns,
                    'type': type
                }
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let fileName = 'Reporte_' + this.title.replace(/\s+/g, '_') + '_' + moment().format('YYYYMMDDHHmmss')
                    let extension = (type === 'xls') ? '.xlsx' : '.pdf';
                    link.setAttribute('download', fileName + extension);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    this.errors = error;
                });
            this.loading = false;
        },
        changeDateStart() {
            let period = _.find(this.filters, {'field': 'period'});
            if (period.date_start > period.date_end) {
                period.date_end = period.date_start;
            }
            this.changeFilter();
        },
        changeDateEnd() {
            let period = _.find(this.filters, {'field': 'period'});
            // console.log(period.date_start);
            // console.log(dateEnd);
            if (period.date_end < period.date_start) {
                period.date_end = period.date_start;
            }
            this.changeFilter();
        },
        changeMonthEnd() {
            let period = _.find(this.filters, {'field': 'period'});
            if (period.month_end < period.month_start) {
                period.month_end = period.month_start;
            }
            this.changeFilter();
        },
        getFiltersInTable() {
            return _.filter(this.filters, {'in_table': true})
        },
        changeFilterItem() {
            this.changeFilter();
        },
        async searchItems(input) {
            if (!_.isUndefined(input) && !_.isNull(input) && input.length > 1) {
                let debounce_fun = _.debounce(async () => {
                    await this.$http.post(`/store/get_items_by_filters`, {
                        'input': input,
                        'filters': this.filters,
                    })
                        .then(response => {
                            this.items = response.data;
                        });
                }, 750);
                debounce_fun();
            }
        },
        changeFilterPerson() {
            this.changeFilter();
        },
        async searchPersons(input) {
            if (!_.isUndefined(input) && !_.isNull(input) && input.length > 1) {
                let debounce_fun = _.debounce(async () => {
                    await this.$http.post(`/store/get_persons_by_filters`, {
                        'input': input,
                        'filters': this.filters,
                    })
                        .then(response => {
                            this.persons = response.data;
                        });
                }, 750);
                debounce_fun();
            }
        },
        clickCreate(value) {
            this.$emit('click-create', value)
        },
        clickOtherReports(value) {
            this.$emit('click-other-reports', value)
        },
        async clickOtherActionExport() {
            let type = this.fileTypeOtherActionExport
            this.loading = true;
            const {sortBy, descending} = this.pagination
            await this.$http({
                url: `/${this.resource}/other_action`,
                method: 'POST',
                responseType: 'blob',
                data: {
                    'sortBy': sortBy,
                    'descending': descending,
                    'filters': this.filters.concat(this.additionalFilters),
                    'select_columns': this.selectVisibleColumns,
                    'type': type
                }
            })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    let fileName = 'Descarga_' + this.title.replace(/\s+/g, '_') + '_' + moment().format('YYYYMMDDHHmmss')
                    let extension = (type === 'xls') ? '.xlsx' : '.pdf';
                    link.setAttribute('download', fileName + extension);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(error => {
                    this.errors = error;
                });
            this.loading = false;
        }
    }
}
</script>
